const React = require('react');
const Layout = require('./src/layout/Layout').default;

exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

// exports.shouldUpdateScroll = () => false;
